'use client';
import React from 'react';
import { Div, Text } from '@pezeshk-book/ui-kit';
import Image from '@elements/image';
import BackgroundImage from '../sub-component/background-image';
import Posts from '@layouts/posts';

const imageSize = {
  HD: {
    width: '320px',
    height: '420px',
  },
  MidHD: {
    width: '320px',
    height: '420px',
  },
  FullHD: {
    width: '420px',
    height: '420px',
  },
};

const BlogSection = ({ blogData, translate }: any) => {
  return (
    <Div className={'w-full flex-col'}>
      <Div className={'flex-col px-2 gap-4 items-center self-center mt-10 md:mt-20'}>
        <Text color={'grey.900'} typography={'xl'} type={'bold'} align={'center'}>{translate.title}</Text>
        <Text color={'grey.500'} align={'start'} typography={'lg'} type={'bold'}>{translate.sub_title}</Text>
      </Div>
      <Div className={'flex-row items-center'}>
        <Div className={'flex-col w-full md:w-[70%] self-center mt-4 sm:mt-12 md:mt-24 md:mb-16'}>
          <Posts
            buttonTitle={translate.buttons.show_more}
            desktop={true}
            items={blogData}
          />
        </Div>
        <BackgroundImage imageSize={imageSize}>
          <Image
            className={'object-contain'}
            alt={'image'}
            src={'/images/home-screen/background-svg/news-paper.png'}
            sizes={'(max-width: 639px) 50vw, (max-width: 1023px) 33vw, 25vw'}/>
        </BackgroundImage>
      </Div>
    </Div>
  );
};
export default BlogSection;
